import { Link } from 'react-router';
import * as s from 'styled-components';
const styled = s.default;

export const ButtonLink: any = styled.a`
  border: none;
  display: flex;
  flex-direction: row;
  width: 100%;
  border-radius: 50px;
  padding: 10px;
  color: #fff;
  text-decoration: none;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  border: none;
  background: ${({ theme }) => theme.btnPrimary};
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
  &:active {
    opacity: 0.6;
  }

  &:focus {
    outline: none;
  }

  &::after {
    min-height: 15px;
  }
`;

export const RouterButton = ButtonLink.withComponent(Link);
